import { useCallback } from 'react'

import { resetCrudSelection } from '@/atoms'

export function useGoBack() {
  return useCallback(() => {
    resetCrudSelection('trafficArea')
  }, [])
}
